module.exports = __webpack_public_path__ + "static/selectpath-logo-507db1457943069d14ec76593d5dfb2f.jpg";